export default {
  data() {
    return {
      filterOrder: [],
      hiddenFilters: [],
    };
  },
  computed: {
    _profileData() {
      return this.$store.getters["profile/getProfileData"];
    },
    isFilterAllowed() {
      return (key) => {
        if (typeof this.isFilterAllowedForKey === "function") {
          return this.isFilterAllowedForKey(key);
        }
        return true;
      };
    },
    orderedFilterMeta() {
      const meta = this.filterMeta || [];
      const byKey = {};
      meta.forEach((f) => (byKey[f.key] = f));
      const ordered = [];
      (this.filterOrder || []).forEach((k) => {
        if (byKey[k]) ordered.push(byKey[k]);
      });
      meta.forEach((f) => {
        if (!this.filterOrder || this.filterOrder.indexOf(f.key) === -1) {
          ordered.push(f);
        }
      });
      return ordered;
    },
    orderedVisibleFilters: {
      get() {
        return this.orderedFilterMeta.filter(
          (f) => this.isFilterAllowed(f.key) && !this.hiddenFilters.includes(f.key)
        );
      },
      set(newVisible) {
        const queue = newVisible.map((f) => f.key);
        const current = this.orderedFilterMeta.map((f) => f.key);
        this.filterOrder = current.map((k) =>
          this.isFilterAllowed(k) && !this.hiddenFilters.includes(k)
            ? queue.shift()
            : k
        );
        this.saveFilterPreferences();
      },
    },
    customizableFilters() {
      return this.orderedFilterMeta.filter((f) => this.isFilterAllowed(f.key));
    },
  },
  watch: {
    _profileData(v) {
      if (
        v &&
        v.filter_preferences &&
        v.filter_preferences[this.filterGroupKey]
      ) {
        this.loadFilterPreferences();
      }
    },
  },
  methods: {
    _filterStorageKey() {
      return `filterPrefs_${this.filterGroupKey}`;
    },
    loadFilterPreferences() {
      const defaultOrder = (this.filterMeta || []).map((f) => f.key);
      let prefs = null;
      const profile = this._profileData;
      if (
        profile &&
        profile.filter_preferences &&
        profile.filter_preferences[this.filterGroupKey]
      ) {
        prefs = profile.filter_preferences[this.filterGroupKey];
      } else {
        try {
          prefs = JSON.parse(localStorage.getItem(this._filterStorageKey()));
        } catch (e) {
          prefs = null;
        }
      }
      const savedOrder = prefs && Array.isArray(prefs.order) ? prefs.order : [];
      const valid = savedOrder.filter((k) => defaultOrder.includes(k));
      this.filterOrder = [
        ...valid,
        ...defaultOrder.filter((k) => !valid.includes(k)),
      ];
      this.hiddenFilters =
        prefs && Array.isArray(prefs.hidden)
          ? prefs.hidden.filter((k) => defaultOrder.includes(k))
          : [];
      // Persistent date-type preference (only for components that expose `dateType`).
      if (this.dateType !== undefined && prefs && prefs.dateType) {
        this.dateType = prefs.dateType;
      }
    },
    async saveFilterPreferences() {
      const payload = { order: this.filterOrder, hidden: this.hiddenFilters };
      if (this.dateType !== undefined) {
        payload.dateType = this.dateType;
      }
      try {
        localStorage.setItem(this._filterStorageKey(), JSON.stringify(payload));
      } catch (e) {}
      try {
        await this.$store.dispatch("profile/updateFilterPreferences", {
          filter_preferences: { [this.filterGroupKey]: payload },
        });
      } catch (e) {
        // non-blocking: local copy already saved
      }
    },
    toggleFilterVisibility(key) {
      if (this.hiddenFilters.includes(key)) {
        this.hiddenFilters = this.hiddenFilters.filter((k) => k !== key);
      } else {
        this.hiddenFilters = [...this.hiddenFilters, key];
      }
      this.saveFilterPreferences();
    },
    resetFilterPreferences() {
      this.filterOrder = (this.filterMeta || []).map((f) => f.key);
      this.hiddenFilters = [];
      if (this.dateType !== undefined) {
        this.dateType = "created_at";
      }
      this.saveFilterPreferences();
    },
  },
};
